import { getAvailableStyles } from '@/map/map-styles';
import { useMapStore } from '@/stores/map-store';
import { ICON_RAIL_WIDTH } from '@/constants/layout';
import { cn } from '@/lib/utils';

/** Map style layer switcher pills positioned top-left of the map area */
export function LayerSwitcher(): React.JSX.Element | null {
  const activeStyleId = useMapStore((s) => s.activeStyleId);
  const setActiveStyleId = useMapStore((s) => s.setActiveStyleId);
  const viewMode = useMapStore((s) => s.viewMode);
  const styles = getAvailableStyles(viewMode);

  // 3D tiles are always photorealistic — basemap styles only apply in 2D.
  if (viewMode === '3d') return null;

  return (
    <div
      className="absolute z-[1000] flex gap-1"
      style={{ left: ICON_RAIL_WIDTH + 12, top: 76 }}
    >
      {styles.map((style) => (
        <button
          key={style.id}
          className={cn(
            'rounded-md px-3 py-1.5 text-xs font-medium transition-colors',
            activeStyleId === style.id
              ? 'bg-echo-yellow text-black'
              : 'bg-echo-grey/85 border border-echo-border text-muted-foreground hover:bg-echo-grey hover:text-foreground',
          )}
          onClick={() => setActiveStyleId(style.id)}
        >
          {style.label}
        </button>
      ))}
    </div>
  );
}
